import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  initialState: [],
  name: "Cart",
  reducers: {
    addToCart: (state = [], action) => {
      const checkItemExists = state.some(
        (item) => item.id === action.payload.id
      );

      if (checkItemExists) {
        return [...state];
      }

      return [
        ...state,
        {
          id: action.payload.id,
          img: action.payload.img,
          name: action.payload.name,
          instructorName: action.payload.instructorName,
          discountPrice: action.payload.discountPrice,
          mrpPrice: action.payload.mrpPrice,
        },
      ];
    },
    removeFromCart: (state, action) => {
      return state.filter((item) => item.id !== action.payload);
    },
    clearCart: (state, action) => {
      return [];
    },

    syncCart: function (state, action) {
      console.log("sync data", action.payload);
      return action.payload;
    },
  },
});

export const { addToCart, removeFromCart, clearCart, syncCart } =
  cartSlice.actions;
export const cartReducer = cartSlice.reducer;
